import { render } from "./HeroAnchor.vue?vue&type=template&id=06da92c2&scoped=true"
import script from "./HeroAnchor.vue?vue&type=script&lang=js"
export * from "./HeroAnchor.vue?vue&type=script&lang=js"

import "./HeroAnchor.vue?vue&type=style&index=0&id=06da92c2&scoped=true&lang=scss"

import exportComponent from "/builds/lahautesociete/projects/roche/depistage-diabete/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06da92c2"]])

export default __exports__